// ** Third Party Components
import {Edit, Trash} from 'react-feather'

// ** Table Common Column
export const columns = (toggleModalEdit, toggleModalDelete) => [
  {
    name: 'Id Area',
    width: '25%',
    center: true,
    selector: row => row.areaId,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.areaId}
      </div>
    )
  },

  {
    name: 'Nombre de area',
    width: '40%',
    sortable: true,
    center: true,
    selector: row => row.areaName
  },

  {
    name: 'Acciones',
    width: '35%',
    center: true,
    allowOverflow: true,
    cell: (row) => {
      return (
        <div className='d-flex'>
          <div className='cursor-pointer text-primary'>
            <Edit onClick={() => toggleModalEdit(true, row)} size={20} />
          </div>
          <div className='ps-1 cursor-pointer text-danger'>
              <Trash onClick={() => toggleModalDelete(true, row)} size={20} />
          </div>
        </div>
      )
    }

  }
]
